import { useState } from "react";
import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Collapse,
  List,
} from "@material-ui/core";
import { Link } from "@backstage/core-components";
import { usePermission } from "@backstage/plugin-permission-react";
import {
  crmonCommissionsPermission,
  crmonReadPermission,
} from "@internal/plugin-crmon";
import PeopleIcon from "@material-ui/icons/People";
import ViewKanbanIcon from "@material-ui/icons/ViewColumn";
import NotificationsIcon from "@material-ui/icons/Notifications";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useRootStyles } from "../../styles/useRootStyles";

interface CrmlyNavItemProps {
  mobile?: boolean;
  onClick?: () => void;
}

export const CrmlyNavItem = ({
  mobile = false,
  onClick,
}: CrmlyNavItemProps) => {
  const classes = useRootStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { allowed: readAllowed } = usePermission({
    permission: crmonReadPermission,
  });
  const { allowed: commissionsAllowed } = usePermission({
    permission: crmonCommissionsPermission,
  });

  if (!readAllowed) return null;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (mobile) {
    return (
      <>
        <ListItem
          button
          onClick={handleMobileToggle}
          className={classes.drawerItem}
        >
          <ListItemIcon className={classes.drawerIcon}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Crmly" />
          {mobileOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={mobileOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              component={Link}
              to="/crmon"
              className={classes.drawerItem}
              onClick={onClick}
              style={{ paddingLeft: 48 }}
            >
              <ListItemIcon className={classes.drawerIcon}>
                <ViewKanbanIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Pipeline" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/crmon/nudges"
              className={classes.drawerItem}
              onClick={onClick}
              style={{ paddingLeft: 48 }}
            >
              <ListItemIcon className={classes.drawerIcon}>
                <NotificationsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Nudges" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/crmon/weekly-sync"
              className={classes.drawerItem}
              onClick={onClick}
              style={{ paddingLeft: 48 }}
            >
              <ListItemIcon className={classes.drawerIcon}>
                <EventNoteIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Weekly Sync" />
            </ListItem>
            {commissionsAllowed && (
              <ListItem
                button
                component={Link}
                to="/crmon/commissions"
                className={classes.drawerItem}
                onClick={onClick}
                style={{ paddingLeft: 48 }}
              >
                <ListItemIcon className={classes.drawerIcon}>
                  <AttachMoneyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Commissions" />
              </ListItem>
            )}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <>
      <Button
        className={classes.navButton}
        startIcon={<PeopleIcon />}
        endIcon={<ArrowDropDownIcon />}
        color="inherit"
        onClick={handleClick}
      >
        Crmly
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem component={Link} to="/crmon" onClick={handleClose}>
          <ListItemIcon>
            <ViewKanbanIcon fontSize="small" />
          </ListItemIcon>
          Pipeline
        </MenuItem>
        <MenuItem component={Link} to="/crmon/nudges" onClick={handleClose}>
          <ListItemIcon>
            <NotificationsIcon fontSize="small" />
          </ListItemIcon>
          Nudges
        </MenuItem>
        <MenuItem
          component={Link}
          to="/crmon/weekly-sync"
          onClick={handleClose}
        >
          <ListItemIcon>
            <EventNoteIcon fontSize="small" />
          </ListItemIcon>
          Weekly Sync
        </MenuItem>
        {commissionsAllowed && (
          <MenuItem
            component={Link}
            to="/crmon/commissions"
            onClick={handleClose}
          >
            <ListItemIcon>
              <AttachMoneyIcon fontSize="small" />
            </ListItemIcon>
            Commissions
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
